import { Card, CardContent, CardHeader, CardTitle } from '@cibli/shared';

import { API_ORIGIN } from '@/lib/api-url';

export function ApiInfoCard() {
  const apiUrl = API_ORIGIN;

  return (
    <Card>
      <CardHeader>
        <CardTitle>API</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm font-mono bg-gray-100 p-2 rounded border">{apiUrl}</p>
      </CardContent>
    </Card>
  );
}
